import { render, staticRenderFns } from "./zcfzb.vue?vue&type=template&id=550e928c&scoped=true&"
import script from "./zcfzb.vue?vue&type=script&lang=js&"
export * from "./zcfzb.vue?vue&type=script&lang=js&"
import style0 from "./zcfzb.vue?vue&type=style&index=0&id=550e928c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550e928c",
  null
  
)

export default component.exports